module.exports = __webpack_public_path__ + "img/3.b4ec6070.jpg";